import React, { useState, useEffect } from "react";
import DescribeGoal from "./Pages/DescribeGoal/DescribeGoal";
import Login from "./Pages/Login/Login";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import Plan from "./Pages/Plan/Plan";
import Template from "./Pages/Templates/Template";
import Steeper from "./Pages/Steeper/Steeper";
import DashBoard from "./Pages/DashBoard/DashBoard";
import MenuCard from "./Pages/MenuCard/MenuCard";
import Appearance from "./Pages/Appearance/Appearance";
import Analytics from "./Pages/Analytics/Analytics";
import Settings from "./Pages/Settings/Settings";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    setIsAuthenticated(!!token);
  }, []);
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={isAuthenticated ? <DashBoard /> : <Login />}
          />
          <Route path="/Steeper" element={<Steeper />} />
          <Route path="/DescribeGoal" element={<DescribeGoal />} />
          <Route path="/Plan" element={<Plan />} />
          <Route path="/Template" element={<Template />} />
          <Route path="/MenuCard" element={<MenuCard />} />
          <Route path="/Appearance" element={<Appearance />} />
          <Route path="/Analytics" element={<Analytics />} />
          <Route path="/Settings" element={<Settings />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
